import { Injectable } from '@angular/core';

/**
 * Tracks whether the user is actively watching a recorded lesson video.
 * Step components (WatchVideo, Youtube, Gallery) set this flag on init/destroy
 * so the idle-logout service knows not to kick the user out mid-video.
 *
 * The virtual classroom does NOT use this flag — idle logout still applies there.
 */
@Injectable({ providedIn: 'root' })
export class MediaActivityService {
  private _watchingLesson = false;

  setWatchingLesson(value: boolean): void {
    this._watchingLesson = value;
  }

  isWatchingLesson(): boolean {
    return this._watchingLesson;
  }
}
